export const initialState = {
  tree: [],
  treeLoading: false,
  filesByFolder: {},
  userCounts: {},
  uploading: false,
  portfolioFilesByFolder: {},
  portfolioFilesByBp: {},
  loadedFolders: new Set(),
  loadingFolders: new Set(),
  loadingProgress: {},
  cursorByKey: {},
  hasMoreByKey: {},
  lastAggregateQuery: {},
}
